module.exports = __webpack_public_path__ + "img/dow_google.ae96a01a.png";